"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WidgetLoadStatus = void 0;
class CalendarConstant {
}
exports.default = CalendarConstant;
CalendarConstant.classes = {
    calendarBody: 'vas-scheduling-calendar',
    elementHide: 'cal-hidden',
    calendarModels: 'calendar-models',
    calendarMetadata: 'calendar-metadata',
    calendarStrings: 'calendar-strings',
    selectedSlots: 'calendar-selected-slots',
    calendarNoSlotsAlert: 'calendar-no-availability-view'
};
CalendarConstant.eventsName = {
    calReloading: '',
    calReloaded: '',
    calRedraw: '',
    dateSelected: '',
    slotSelected: '',
    slotDeselected: '',
    nextDatesClicked: '',
    prevDatesClicked: ''
};
var WidgetLoadStatus;
(function (WidgetLoadStatus) {
    WidgetLoadStatus["Success"] = "SUCCESS";
    WidgetLoadStatus["Failure"] = "FAILURE";
    WidgetLoadStatus["NoSlots"] = "NO_SLOTS";
})(WidgetLoadStatus = exports.WidgetLoadStatus || (exports.WidgetLoadStatus = {}));
